// 区分正常请求失败与已被新调用替代的结果。
const STALE_REQUEST_CODE = 'REQUEST_STALE';

// 已完成的旧调用以拒绝态结束，跳过后续成功回调。
function createStaleRequestError() {
  // 过期是调用控制信号，不由本工具展示错误提示。
  const error = new Error('请求结果已过期');
  error.code = STALE_REQUEST_CODE;
  return error;
}

export default {
  /**
   * 为当前调用方创建独立的最新任务执行器，不取消网络请求、不维护 loading。
   * run(key, fn) 返回普通 Promise；同一 key 只接受最新调用的结果，旧调用拒绝为 REQUEST_STALE。
   * fn 仅负责返回结果，界面赋值放在 run 返回的 Promise 后；真实失败原样透传。
   * 版本判断发生在 fn 完成时，已经落定的 Promise 不会被撤销。
   * finally 始终执行，修改 loading 前应使用 isLatest(key, promise) 判断归属。
   * 每个组件实例创建一次，关闭或销毁时调用 invalidateAll()。
   */
  createLatestRunner() {
    // 相同任务名只记录最后一次调用的 Promise，不同调用方不共享状态。
    const latestTasks = new Map();
    // 保留已完成任务的归属，供调用方在 finally 中判断。
    const isLatest = (key, promise) => latestTasks.get(key) === promise;

    return {
      // 同步抛错也转换为 Promise 拒绝，使用方统一通过 catch 处理。
      run(key, fn) {
        // 每次调用均创建独立 Promise，避免失效后重新调用时误认旧结果。
        const promise = Promise.resolve()
          .then(fn)
          .then(
            (data) => {
              if (!isLatest(key, promise)) throw createStaleRequestError();
              return data;
            },
            (error) => {
              if (!isLatest(key, promise)) throw createStaleRequestError();
              throw error;
            },
          );
        latestTasks.set(key, promise);
        return promise;
      },
      isLatest,
      // 让当前所有任务失效，后续仍可使用同一执行器发起新任务。
      invalidateAll() {
        latestTasks.clear();
      },
    };
  },
  // 有自定义错误逻辑时，可用此方法静默跳过过期结果。
  isStaleRequest(error) {
    return error?.code === STALE_REQUEST_CODE;
  },
};
